import PropTypes from 'prop-types';

import Link from 'Component/Link';
import { CategoryPaginationLink as SourceCategoryPaginationLink } from 'SourceComponent/CategoryPaginationLink/CategoryPaginationLink.component';

import './CategoryPaginationLink.override.style';

/** @namespace AdvoxBasic/Component/CategoryPaginationLink/Component/CategoryPaginationLink */
export class CategoryPaginationLink extends SourceCategoryPaginationLink {
    static propTypes = {
        ...SourceCategoryPaginationLink.propTypes,
        isButton: PropTypes.bool,
    };

    static defaultProps = {
        ...SourceCategoryPaginationLink.defaultProps,
        isButton: false,
    };

    getPage = () => {
        const { getPage, pageNumber } = this.props;
        getPage(pageNumber);
    };

    render() {
        const { label, url_path: pathname, isCurrent, children, isButton } = this.props;

        const search = this.getSearchQueryForPage();

        const { state = {} } = history.state || {};

        if (isButton) {
            return (
                <button
                    aria-label={label}
                    block="CategoryPaginationLink"
                    mods={{ isCurrent, isArrow: typeof children !== 'string' }}
                    aria-current={isCurrent ? 'page' : 'false'}
                    onClick={this.getPage}
                    type="button"
                >
                    {children}
                </button>
            );
        }

        return (
            <Link
                to={{
                    search,
                    pathname,
                    state,
                }}
                aria-label={label}
                block="CategoryPaginationLink"
                mods={{ isCurrent, isArrow: typeof children !== 'string' }}
                aria-current={isCurrent ? 'page' : 'false'}
                onClick={this.getPage}
            >
                {children}
            </Link>
        );
    }
}

export default CategoryPaginationLink;
